document.addEventListener('DOMContentLoaded', () => {
  const overlays = Array.from(document.querySelectorAll('.form-popup-overlay'));
  const triggers = Array.from(document.querySelectorAll('.formstack-open-popup'));
  if (!overlays.length || !triggers.length) return;

  const getClosest = (event, selector) => {
    const target = event.target;
    if (!(target instanceof Element)) return null;
    return target.closest(selector);
  };

  const normalizeScriptSrc = (src) => {
    if (!src) return '';
    return src.replace(/^https?:/, '').replace(/[?#].*$/, '');
  };

  const getPopup = (overlay) => overlay?.querySelector('.form-popup') || null;

  const getOverlayScriptSrc = (overlay) => {
    const popup = getPopup(overlay);
    const script = popup?.querySelector('script[src*="formstack.com/forms/js.php/"]');
    return normalizeScriptSrc(script?.getAttribute('src') || '');
  };

  const hasRenderedForm = (overlay) => {
    const popup = getPopup(overlay);
    if (!popup) return false;

    return Boolean(
      popup.querySelector('form') ||
      popup.querySelector('.fsForm') ||
      popup.querySelector('.fsBody') ||
      popup.querySelector('iframe[src*="formstack.com/forms/"]')
    );
  };

  const showOverlay = (overlay) => {
    if (!overlay) return;

    overlay.classList.add('active');
    overlay.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('no-scroll');
    document.body.classList.add('has-overlay');
  };

  const hideOverlay = (overlay) => {
    if (!overlay) return;

    overlay.classList.remove('active');
    overlay.classList.remove('is-active');

    const hasOpenOverlay = overlays.some((item) =>
      item.classList.contains('active') || item.classList.contains('is-active')
    );

    if (!hasOpenOverlay) {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('no-scroll');
      document.body.classList.remove('has-overlay');
    }
  };

  const resolveLocalOverlay = (trigger) => {
    const blockOverlay = trigger.closest('.formstack-block')?.querySelector('.form-popup-overlay');
    if (blockOverlay) return blockOverlay;

    const section = trigger.closest('[id^="shopify-section-"]');
    return section?.querySelector('.form-popup-overlay') || null;
  };

  const canonicalByScript = new Map();
  overlays.forEach((overlay) => {
    const scriptSrc = getOverlayScriptSrc(overlay);
    if (!scriptSrc || canonicalByScript.has(scriptSrc)) return;
    canonicalByScript.set(scriptSrc, overlay);
  });

  const getFirstRenderedOverlay = () => overlays.find((overlay) => hasRenderedForm(overlay)) || null;

  const getTargetOverlay = (trigger) => {
    const localOverlay = resolveLocalOverlay(trigger);
    if (!localOverlay) return null;

    const scriptSrc = getOverlayScriptSrc(localOverlay);
    const canonicalOverlay = scriptSrc ? canonicalByScript.get(scriptSrc) : null;
    const preferredOverlay = canonicalOverlay || localOverlay;

    if (hasRenderedForm(preferredOverlay)) {
      return preferredOverlay;
    }

    return getFirstRenderedOverlay() || preferredOverlay;
  };

  triggers.forEach((trigger) => {
    if (trigger.classList.contains('d-none')) {
      trigger.classList.remove('d-none');
    }
  });

  // Capture phase stops duplicated section-level popup handlers from opening empty overlays.
  document.addEventListener(
    'click',
    (event) => {
      const trigger = getClosest(event, '.formstack-open-popup');
      if (!trigger || event.target?.href) return;

      const targetOverlay = getTargetOverlay(trigger);
      showOverlay(targetOverlay);

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  overlays.forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
      // Close only when the backdrop itself is clicked.
      if (event.target === overlay) {
        hideOverlay(overlay);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    overlays.forEach((overlay) => {
      if (overlay.classList.contains('active') || overlay.classList.contains('is-active')) {
        hideOverlay(overlay);
      }
    });
  });

  document.body.addEventListener('click', (event) => {
    if (getClosest(event, 'a[title="close"]')) {
      overlays.forEach((overlay) => hideOverlay(overlay));
    }
  });
});
